import {toString} from 'lodash';
import {OvbuilderDetails_ovrecommendDetails} from '../../../schema-types/OvbuilderDetails';
import {setUpProtectionFields} from '../BuilderSetUpNew/builderProtectionFields';

export const getProtectionInitialValues = (
  builderDetails: OvbuilderDetails_ovrecommendDetails | null
): setUpProtectionFields | undefined => {
  const protection = builderDetails?.protection;
  if (!protection) {
    return undefined;
  }

  return {
    protectionType: protection.protectionType,
    livesAssured: protection.livesAssured ?? undefined,
    premiumType: protection.premiumType ?? undefined,
    deferredPeriod: protection.deferredPeriod ?? undefined,
    termType: protection.termType ?? undefined,
    notes: protection.notes ?? undefined,
    // Decimals -> string. `!= null` keeps a stored 0 as "0".
    lifeCover: protection.lifeCover != null ? String(protection.lifeCover) : undefined,
    monthlyIncome:
      protection.monthlyIncome != null ? String(protection.monthlyIncome) : undefined,
    criticalIllnessCover:
      protection.criticalIllnessCover != null
        ? String(protection.criticalIllnessCover)
        : undefined,
    lifeOrCriticalIllnessCover:
      protection.lifeOrCriticalIllnessCover != null
        ? String(protection.lifeOrCriticalIllnessCover)
        : undefined,
    // Int -> string (form fields hold strings; the save path re-numbers them).
    term: protection.term != null ? toString(protection.term) : undefined,
    terminatingAge:
      protection.terminatingAge != null ? toString(protection.terminatingAge) : undefined,
    // is-prefixed on the resolver; un-prefixed on the form.
    inTrust: protection.isInTrust ?? false,
    investmentLinked: protection.isInvestmentLinked ?? false,
    waiverOfPremium: protection.isWaiverOfPremium ?? false,
  };
};
